export const isMobile = () => {
    // 모바일 기기를 식별하기 위한 사용자 에이전트 정규식
    const mobileRegex = /android|bb\d+|meego|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile|netfront|opera m(ob|in)i|palm|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up(\.b|g1|si)|vodafone|wap|windows (ce|phone)|xda|xiino|zte|silk/i;

    // 사용자 에이전트에서 모바일 기기 여부 확인
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 정규식을 통해 모바일 기기 확인
    return mobileRegex.test(userAgent.toLowerCase());
};